import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CreateBuildingPage } from './create-building.page';

const routes: Routes = [
  {
    path: '',
    component: CreateBuildingPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CreateBuildingPageRoutingModule {}
